import { render, staticRenderFns } from "./TreemapArea.vue?vue&type=template&id=4c196ac2&lang=pug&"
import script from "./TreemapArea.vue?vue&type=script&lang=ts&"
export * from "./TreemapArea.vue?vue&type=script&lang=ts&"
import style0 from "./TreemapArea.vue?vue&type=style&index=0&id=4c196ac2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports